// extracted by mini-css-extract-plugin
module.exports = {"controlPane":"ControlPane_controlPane__2PHPZ","title":"ControlPane_title__211m3","metadata":"ControlPane_metadata__3QqUG"};